import CompanyIcon from '@material-ui/icons/ViewList';

import EduDataList from './EduDataList';
import EduDataShow from './EduDataShow';

export default {
    list: EduDataList,
    show: EduDataShow,
    icon: CompanyIcon,
};
